import { Component } from '@angular/core';
import { TimelineMax } from 'gsap';
import { IconService } from '../../core/icon.service';
import { params as paramsSocial } from './social.params';
import * as _ from 'lodash';
import {BasicChartComponent} from '../animation-base-classes/basic-chart.component';

@Component({
  selector: 'app-demo-statbel-triptych-bar',
  templateUrl: './demo-statbel-triptych-bar.component.html',
  styleUrls: ['./demo-statbel-triptych-bar.component.scss']
})
export class DemoStatbelTriptychBarComponent extends BasicChartComponent {

  private slide01Group;
  private slide01ContentGroup;
  private slide02Group;
  private slide02ContentGroup;
  private slide03Group;
  private slide03ContentGroup;

  constructor(
    public iconService: IconService,
  ) {
    super(iconService);
    this.paramObject = {
      'social': paramsSocial,
    };
  }

  public async calculateValues() {
    super.calculateValues();
    this.createBarScales(this.data, this.values);
  }

  public async createElements() {

    this.slide01Group = this.host.select('#slide-01');
    this.slide01ContentGroup = this.host.select('#slide-01-content');
    this.slide01ContentGroup.selectAll('*').remove();
    this.drawSlideBarHorSteps(this.slide01ContentGroup, this.values, this.data);

    this.slide02Group = this.host.select('#slide-02');
    this.slide02ContentGroup = this.host.select('#slide-02-content');
    this.slide02ContentGroup.selectAll('*').remove();
    this.drawTextSlideWithTitle(this.slide02ContentGroup, this.values);

    this.slide03Group = this.host.select('#slide-03');
    this.slide03ContentGroup = this.host.select('#slide-03-content');
    this.slide03ContentGroup.selectAll('*').remove();
    this.drawLogoSlideStatbel(this.slide03ContentGroup, this.values);
  }

  public async createAnimation(noAnimation: boolean = false) {
    let main = new TimelineMax({ repeat: -1 });
    if (!noAnimation) {

      let slide01AnimationTotal = new TimelineMax();

      // slide 1
      let stepsAnimation = new TimelineMax();
      this.animateSteps(stepsAnimation, this.values);
      this.animateUnit(stepsAnimation, this.values);
      slide01AnimationTotal.add(stepsAnimation);

      let barAnimation = new TimelineMax();
      this.animateNBars(barAnimation, this.values, this.data);
      slide01AnimationTotal.add(barAnimation);

      let pauseBar = new TimelineMax()
        .set({}, {}, 1)
        .duration(this.timings['pauseBar']);
      slide01AnimationTotal.add(pauseBar);

      let barColorAnimation = new TimelineMax();
      this.animateColorSpecificBar(barColorAnimation, this.values, 11);
      slide01AnimationTotal.add(barColorAnimation);

      let pauseSlide1 = new TimelineMax()
        .set({}, {}, 'positionForStill')
        .set({}, {}, 1)
        .duration(this.timings['pauseSlide1']);
      slide01AnimationTotal.add(pauseSlide1);

      let slide1Animation = new TimelineMax();
      slide1Animation.to(this.slide01Group.node(), 1, { x: -this.values['width'] }, 'startSlide01Animation');
      slide01AnimationTotal.add(slide1Animation);

      slide01AnimationTotal.duration(this.timings['slide1Animation']);
      main.add(slide01AnimationTotal);

      // slide 2
      let slide02AnimationTotal = new TimelineMax();

      let bullet1Animation = new TimelineMax();
      this.animateNBullets(bullet1Animation, this.values, this.data, 1);
      slide02AnimationTotal.add(bullet1Animation);

      let bullet2Animation = new TimelineMax();
      this.animateNBullets(bullet2Animation, this.values, this.data, 2);
      slide02AnimationTotal.add(bullet2Animation);

      let bullet3Animation = new TimelineMax();
      this.animateNBullets(bullet3Animation, this.values, this.data, 3);
      slide02AnimationTotal.add(bullet3Animation);

      let bullet4Animation = new TimelineMax();
      this.animateNBullets(bullet4Animation, this.values, this.data, 4);
      slide02AnimationTotal.add(bullet4Animation);

      let pauseSlide2 = new TimelineMax()
        .set({}, {}, 1)
        .duration(this.timings['pauseSlide2']);
      slide02AnimationTotal.add(pauseSlide2);
      let slide02Animation = new TimelineMax();
      slide02Animation.duration(this.timings['slide02Animation']);
      slide02Animation.to(this.slide02Group.node(), 1, { x: -this.values['width'] }, 'startSlide02Animation');
      slide02AnimationTotal.add(slide02Animation);
      main.add(slide02AnimationTotal);

      // slide 3
      let slide03AnimationTotal = new TimelineMax();
      // Logo animation
      let logoStatbelAnimation = new TimelineMax()
          .set({}, {}, 2);
      this.animateStatbelLogoAppearAndScaleBarsAllAtOnce(logoStatbelAnimation);
      logoStatbelAnimation.duration(this.timings['logoAnimation']);
      slide03AnimationTotal.add(logoStatbelAnimation);
      main.add(slide03AnimationTotal);

      let pauseAnimation = new TimelineMax()
        .set({}, {}, 1)
        .duration(this.timings['pauseEnd']);
      main.add(pauseAnimation);
    }

    this.animation = main;
    return this.animation;
  }

  public drawLogoSlideStatbel(selection, values) {
    this.drawBackgroundLogo(selection, values);
    this.drawStatBelLogo(selection, values);
    this.drawStatbelAdres(selection, values);
  }

  public drawBackgroundLogo (selection, values) {

    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', '#FFFFFF')
      .attr('stroke', '#d9e1e9');
  }

  public drawBackgroundStatbel (selection, values) {
    selection.append('rect')
      .attr('x', 0)
      .attr('y', 0)
      .attr('width', values['width'])
      .attr('height', values['height'])
      .attr('fill', this.lightenDarkenColor(values['colorScheme']['value'][0], -10))
      .attr('stroke', 'none');
    selection.append('rect')
      .attr('x', values['marginLeft'])
      .attr('y', values['marginTop'])
      .attr('width', values['width'] - (values['marginLeft'] + values['marginRight']) )
      .attr('height', values['height'] - (values['marginTop'] + values['marginBottom']))
      .attr('fill', '#FFFFFF')
      .attr('stroke', '#d9e1e9');
  }

  public drawStatBelLogo(selection, values) {
    const logoWidth = 150;
    const logoHeight = 34;
    let factor;
    if (values['statbelLogoWidth']) {
      factor = values['statbelLogoWidth'] / logoWidth;
      // console.log(`Statbel logo height: ${logoHeight * factor}`);
    } else if (values['statbelLogoHeight']) {
      factor = values['statbelLogoHeight'] / logoHeight;
      // console.log(`Statbel logo width: ${logoWidth * factor}`);
    } else {
      factor = 1;
    }

    let ltrColor = '#000000';
    let barBlackColor = '#000000';
    let barYellowColor = '#E62E27';
    let barRedColor = '#FFD415';
    let barGrayColor = '#989898';

    let outerGroup = selection.append('g')
      .attr('id', `statbel-logo-outer-group-${this.id}`)
      .attr('transform', `translate(${values['width'] / 2 - values['statbelLogoWidth'] / 2} ${values['statbelLogoY']})`);
    let innerGroup = outerGroup.append('g')
      .attr('id', `statbel-logo-inner-group-${this.id}`)
      .attr('transform', `scale(${factor} ${factor})`);

    let textGroup = innerGroup.append('g')
      .attr('id', `statbel-logo-text-group-${this.id}`);

    let ltr01 = textGroup.append('path')
      .attr('id', `statbel-logo-ltr01-s-${this.id}`)
      .attr('fill', ltrColor)
      .attr('d', 'M24.4,19.8c0.9,1.5,2.4,2.3,4.2,2.3c2.3,0,4.1-1.4,4.1-3.6c0-5.1-9.5-2.1-9.5-9.1c0-3.3,2.8-5,5.9-5c2,0,3.8,0.7,5,2.3    l-1.5,1.1C31.7,6.6,30.6,6,29,6C26.8,6,25,7.1,25,9.5c0,5.5,9.5,2.2,9.5,9.1c0,3.3-2.7,5.2-5.7,5.2c-2.4,0-4.5-0.8-6-2.8L24.4,19.8z');
    let ltr02 = textGroup.append('path')
      .attr('id', `statbel-logo-ltr02-t-${this.id}`)
      .attr('fill', ltrColor)
      .attr('d', 'M42.5,6.5h-6.3V4.9h14.3v1.6h-6.3v16.8h-1.7C42.6,23.2,42.6,6.5,42.5,6.5z');
    let ltr03 = textGroup.append('path')
      .attr('id', `statbel-logo-ltr03-a-${this.id}`)
      .attr('fill', ltrColor)
      .attr('d', 'M57.2,4.9h1.8l7.7,18.4h-1.9l-2-4.9h-9.7l-2.1,4.9h-1.8L57.2,4.9z M58,6.8l-4.3,10.1h8.4L58,6.8z');
    let ltr04 = textGroup.append('path')
      .attr('id', `statbel-logo-ltr04-t-${this.id}`)
      .attr('fill', ltrColor)
      .attr('d', 'M71.8,6.5h-6.3V4.9h14.3v1.6h-6.3v16.8h-1.7V6.5z');
    let ltr05 = textGroup.append('path')
      .attr('id', `statbel-logo-ltr05-b-${this.id}`)
      .attr('fill', ltrColor)
      .attr('d', 'M81.9,4.9h6.9c3.2,0,6.7,0.7,6.7,4.7c0,2.1-1.3,3.5-3.2,4.1v0.1c2.4,0.3,4,2.1,4,4.5c0,3.8-3.6,5.1-6.9,5.1h-7.5V4.9z M86,12.2h2.9c1.2,0,2.5-0.5,2.5-2s-1.5-1.9-2.7-1.9h-2.8L86,12.2L86,12.2z M86,19.8h3.6c1.3,0,2.7-0.5,2.7-2.2s-2-2-3.3-2h-3.1v4.2H86z');
    let ltr06 = textGroup.append('path')
      .attr('id', `statbel-logo-ltr06-e-${this.id}`)
      .attr('fill', ltrColor)
      .attr('d', 'M98.9,4.9h12.5v3.7h-8.4V12h8v3.7h-8v3.7h8.9v3.7H99C99,23.1,99,4.9,98.9,4.9z');
    let ltr07 = textGroup.append('path')
      .attr('id', `statbel-logo-ltr07-l-${this.id}`)
      .attr('fill', ltrColor)
      .attr('d', 'M115.3,4.9h4.1v14.7h7.5v3.7h-11.6V4.9z');

    let leftBarGroup = innerGroup.append('g');

    let ltl = leftBarGroup.append('path')
      .attr('id', `statbel-logo-bars-ltl-${this.id}`)
      .attr('fill', barBlackColor)
      .attr('d', 'M2.8,0.1H1.1C0.7,0.1,0.2,0.5,0.2,1v12.5h3.5V0.9C3.6,0.4,3.3,0.1,2.8,0.1z');
    let ltm = leftBarGroup.append('path')
      .attr('id', `statbel-logo-bars-ltm-${this.id}`)
      .attr('fill', barYellowColor)
      .attr('d', 'M9.5,6.5H7.8c-0.4,0-0.9,0.4-0.9,0.9v6.1h3.5V7.4C10.4,6.9,10,6.5,9.5,6.5z');
    let ltr = leftBarGroup.append('path')
      .attr('id', `statbel-logo-bars-ltr-${this.id}`)
      .attr('fill', barRedColor)
      .attr('d', 'M17.1,12.5c0-0.5-0.4-0.9-0.9-0.9h-1.7c-0.4,0-0.9,0.4-0.9,0.9v1h3.5C17.1,13.5,17.1,12.5,17.1,12.5z');
    let lbl = leftBarGroup.append('path')
      .attr('id', `statbel-logo-bars-lbl-${this.id}`)
      .attr('fill', barGrayColor)
      .attr('d', 'M0.2,27.2c0,0.5,0.4,0.9,0.9,0.9h1.7c0.5,0,0.9-0.4,0.9-0.9V14.8H0.2V27.2z');
    let lbm = leftBarGroup.append('path')
      .attr('id', `statbel-logo-bars-lbm-${this.id}`)
      .attr('fill', barGrayColor)
      .attr('d', 'M6.9,20.8c0,0.5,0.4,0.9,0.9,0.9h1.7c0.5,0,0.9-0.4,0.9-0.9v-6.1H6.9V20.8z');
    let lbr = leftBarGroup.append('path')
      .attr('id', `statbel-logo-bars-lbr-${this.id}`)
      .attr('fill', barGrayColor)
      .attr('d', 'M13.7,14.8v1c0,0.5,0.4,0.9,0.9,0.9h1.7c0.5,0,0.9-0.4,0.9-0.9v-1H13.7z');

    let rightBarGroup = innerGroup.append('g');

    let rtl = rightBarGroup.append('path')
      .attr('id', `statbel-logo-bars-rtl-${this.id}`)
      .attr('fill', barBlackColor)
      .attr('d', 'M132.8,12.5c0-0.5,0.4-0.9,0.9-0.9h1.7c0.4,0,0.9,0.4,0.9,0.9v1h-3.5L132.8,12.5L132.8,12.5z');
    let rtm = rightBarGroup.append('path')
      .attr('id', `statbel-logo-bars-rtm-${this.id}`)
      .attr('fill', barYellowColor)
      .attr('d', 'M140.4,6.5h1.7c0.4,0,0.9,0.4,0.9,0.9v6.1h-3.5V7.4C139.5,6.9,139.9,6.5,140.4,6.5z');
    let rtr = rightBarGroup.append('path')
      .attr('id', `statbel-logo-bars-rtr-${this.id}`)
      .attr('fill', barRedColor)
      .attr('d', 'M147.1,0.1h1.7c0.4,0,0.9,0.4,0.9,0.9v12.5h-3.5V0.9C146.2,0.4,146.6,0.1,147.1,0.1z');
    let rbl = rightBarGroup.append('path')
      .attr('id', `statbel-logo-bars-rbl-${this.id}`)
      .attr('fill', barGrayColor)
      .attr('d', 'M136.2,14.8v1c0,0.5-0.4,0.9-0.9,0.9h-1.7c-0.5,0-0.9-0.4-0.9-0.9v-1H136.2z');
    let rbm = rightBarGroup.append('path')
      .attr('id', `statbel-logo-bars-rbm-${this.id}`)
      .attr('fill', barGrayColor)
      .attr('d', 'M143,20.8c0,0.5-0.4,0.9-0.9,0.9h-1.7c-0.5,0-0.9-0.4-0.9-0.9v-6.1h3.5V20.8L143,20.8z');
    let rbr = rightBarGroup.append('path')
      .attr('id', `statbel-logo-bars-rbr-${this.id}`)
      .attr('fill', barGrayColor)
      .attr('d', 'M149.8,27.2c0,0.5-0.4,0.9-0.9,0.9h-1.7c-0.5,0-0.9-0.4-0.9-0.9V14.8h3.5V27.2L149.8,27.2z');

    return outerGroup;
  }

  public drawStatbelAdres(selection, values) {

    selection.append('text')
      .attr('id', `twitter-${this.id}`)
      .attr('x', values['width'] / 2)
      .attr('y', values['statbelLogoY'] + 170)
      .attr('text-anchor', 'middle')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', 'Roboto, sans-serif')
      .attr('opacity', 0.8)
      .text('@Statbel_nl');
    selection.append('text')
      .attr('id',  `website-${this.id}` )
      .attr('x', values['width'] / 2)
      .attr('y', values['statbelLogoY'] + 200)
      .attr('text-anchor', 'middle')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', 'Roboto, sans-serif')
      .attr('opacity', 0.8)
      .text('www.statbel.fgov.be');
  }

  public drawSlideBarHorSteps(selection, values, data) {
    this.drawBackgroundStatbel(selection, values);
    this.drawTitleText1(selection, values);
    this.drawTitleText2(selection, values);

    this.drawSteps(selection, values, data);
    this.drawBars(selection, values, data);
    this.drawXAxisSteps(selection, values, data);
    this.drawXAxisLabels(selection, values, data);

   }

  public drawTextSlideWithTitle(selection, values) {
    this.drawBackgroundStatbel(selection, values);
    this.drawTextTitle(selection, values);
    this.drawText(selection, values, 1, 0);
    this.drawText(selection, values, 2, 90);
    this.drawText(selection, values, 3, 135);
    this.drawText(selection, values, 4, 225);
   // this.drawStatbelIcon(selection, values)
  }

  public drawText(selection, values, listnumber, offset) {
    let singleReturn = /\r\n|\n|\f/g;
    let lines = values[`text${listnumber}`].split(singleReturn);
    let rowNumber = lines.length;
    let lineHeight = values['textFontSize'] * values['textLineHeight'];
    let height = rowNumber * lineHeight;
    // let y = values['height'] / 2 - height / 2; // Deze is geschikt voor uitlijnen in het midden
    let y =  values['chartDomainY'] + offset;
    let g = selection.append('g')
      .attr('id', `bulletGroep-${this.id}-${listnumber}`)
    let bullet = g.append('circle')
      .attr('id', `bullet-${this.id}-${listnumber}`)
      .attr('r', values['bulletRadius'])
      .attr('cx', values['titleOffsetX'] + values['marginLeft'] + (values['bulletRadius']))
      .attr('cy', y +  (lineHeight / 3))
      .attr('fill', values['bulletColor']);


    _.map(lines, (line, index) => {
      let text = g.append('text')
        .attr('id', `bulletText-${this.id}-${listnumber}`)
        .attr('dominant-baseline', 'hanging')
        .attr('fill', values['textFontColor'])
        .attr('font-size', values['textFontSize'])
        .attr('font-family', 'Roboto, sans-serif')
        .attr('text-anchor', 'start')
        .attr('x', values['titleOffsetX'] + values['marginLeft'] + 2 * values['labelOffsetY'])
        .attr('y', y + index * lineHeight)
        .text(line);
    });
  }

  public drawTextTitle(selection, values) {
    selection.append('text')
      .attr('x', values['titleOffsetX'] + values['marginLeft'])
      .attr('y', values['titleOffsetY'] + values['marginTop'])
      .attr('fill', values['titleColor'])
      .attr('font-family', 'Roboto, sans-serif')
      .attr('font-size', values['titleFontSize'])
      .attr('font-weight', values['titleFontWeight'])
      .text(values['titleText']);
  }

  public drawTitleText1(selection, values) {
    selection.append('text')
      .attr('x', values['titleOffsetX'] + values['marginLeft'])
      .attr('y', values['title1OffsetY'] + values['marginTop'])
      .attr('fill', values['titleColor'])
      .attr('font-family', 'Roboto, sans-serif')
      .attr('font-size', values['titleFontSize'])
      .attr('font-weight', values['titleFontWeight'])
      .text(values['titleText1']);
  }

  public drawTitleText2(selection, values) {
    selection.append('text')
      .attr('x', values['titleOffsetX'] + values['marginLeft'])
      .attr('y', values['title2OffsetY'] + values['marginTop'])
      .attr('fill', values['titleColor'])
      .attr('font-family', 'Roboto, sans-serif')
      .attr('font-size', values['titleFontSize'])
      .attr('font-weight', values['titleFontWeight'])
      .text(values['titleText2']);
  }

  public drawXAxisSteps(selection, values, data) {
    let g = selection.append('g')

    let xAxis = g.append('line')
      .attr('id', `xAxis-${this.id}`)
      .attr('x1', values['chartDomainX'] - values['axisStrokeWidth'] / 2)
      .attr('x2', values['chartDomainX'] + values['chartDomainWidth'])
      .attr('stroke', values['colorScheme']['value'][1])
      .attr('stroke-width', values['axisStrokeWidth']);
    // If minY is 0 or greater draw the X axis at the bottom
    if (values['minY'] >= 0) {
      xAxis.attr('y1', values['chartDomainY'] + values['chartDomainHeight'])
        .attr('y2', values['chartDomainY'] + values['chartDomainHeight']);
      // If maxY is 0 or less draw the X axis at the top
    } else if (values['maxY'] < 0) {
      xAxis.attr('y1', values['chartDomainY'])
        .attr('y2', values['chartDomainY']);
      // If 0 is between minY and maxY draw a 0 axis
    } else {
      xAxis.attr('y1', this.scaleY(0))
        .attr('y2', this.scaleY(0));
    }

    values['step'] = (values['maxY'] - values['minY']) / (values['steps']);

    let y0Label = values['maxY'] < 0 ? values['maxY'] : values['minY'] > 0 ? values['minY'] : 0;

    let yLabelAs = g.append('text')
      .attr('id', `step-label0-${this.id}`)
      .attr('text-anchor', 'end')
      .attr('x', values['chartDomainX'] - values['labelOffsetY'])
      .attr('y', this.scaleY(y0Label))
      .attr('dominant-baseline', 'middle')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', 'Roboto, sans-serif')
    //  .text(this.formatNumberDecimals(y0Label, values['labelDecimalsY'], values['formatLocale']['value']));
      .text(y0Label + '%');

  }

  public drawSteps (selection, values, data) {

    let g = selection.append('g');
    let y0Label = values['maxY'] < 0 ? values['maxY'] : values['minY'] > 0 ? values['minY'] : 0;
    values['step'] = (values['maxY'] - values['minY']) / (values['steps']);
    for (let idx: number = 1; idx <= values['steps']; idx++) {
      let yValue;
      let steps = g.append('line')
        .attr('id', `step${idx}-${this.id}`)
        .attr('x1', values['chartDomainX'] - values['axisStrokeWidth'] / 2)
        .attr('x2', values['chartDomainX'] + values['chartDomainWidth'])
        .attr('stroke', values['colorScheme']['value'][1])
        .attr('stroke-width', values['axisStrokeWidth'])
        .attr('opacity', 0.5);
      // If minY is 0 or greater draw the X axis at the bottom
      if (values['maxY'] <= 0) {
        yValue = - idx * values['step'];
        steps.attr('y1', yValue)
          .attr('y2', yValue);
        // If 0 is between minY and maxY draw a 0 axis
      }
      else if (values['minY'] < 0) {
        yValue = values['minY'] + idx * values['step'] <= y0Label ? - idx * values['step'] : values['minY'] + idx * values['step'];
        steps.attr('y1', this.scaleY(yValue))
          .attr('y2', this.scaleY(yValue));
        // If 0 is between minY and maxY draw a 0 axis
      } else {
        yValue = values['minY'] + idx * values['step'];
        steps.attr('y1', this.scaleY(yValue))
          .attr('y2', this.scaleY(yValue));
      }
      let label = g.append('text')
        .attr('id', `step-label${idx}-${this.id}`)
        .attr('text-anchor', 'end')
        .attr('x', values['chartDomainX'] - values['labelOffsetY'])
        .attr('y', this.scaleY(yValue))
        .attr('dominant-baseline', 'middle')
        .attr('fill', values['labelColor'])
        .attr('font-size', values['labelFontSize'])
        .attr('font-family', 'Roboto, sans-serif')
        .text(yValue + '%')
        // .text(this.formatNumberDecimals(yValue, values['labelDecimalsY'], values['formatLocale']['value'], ));
    };
  }

  public drawXAxisLabels(selection, values, data) {
    let list = _.map(this.data, a => a[0]);
    let xAxisLeftLabel = selection.append('text')
      .attr('id', `xAxisLeftLabel-${this.id}`)
      .attr('text-anchor', 'middle')
      .attr('dy', '0.7em')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', 'Roboto, sans-serif')
      .text(values['leftLabelX']);
    let xAxisRightLabel = selection.append('text')
      .attr('id', `xAxisRightLabel-${this.id}`)
      .attr('x', this.scaleX(list.length - 1) + this.scaleX.bandwidth() / 2)
      .attr('text-anchor', 'middle')
      .attr('dy', '0.7em')
      .attr('fill', values['labelColor'])
      .attr('font-size', values['labelFontSize'])
      .attr('font-family', 'Roboto, sans-serif')
      .text(values['rightLabelX']);

    // If minY is 0 or greater draw the X axis labels at the bottom
    if (values['minY'] >= 0) {
      xAxisLeftLabel
        .attr('y', values['chartDomainY'] + values['chartDomainHeight'] + values['labelOffsetX'])
        .attr('x', this.scaleX(0) + this.scaleX.bandwidth() / 2);
      xAxisRightLabel
        .attr('y', values['chartDomainY'] + values['chartDomainHeight'] + values['labelOffsetX']);
      // If maxY is 0 or less draw the X axis labels at the top
    } else if (values['maxY'] <= 0) {
      xAxisLeftLabel
        .attr('y', values['chartDomainY'] + values['labelOffsetX'])
        .attr('x', this.scaleX(0) + this.scaleX.bandwidth() / 2);
      xAxisRightLabel
        .attr('y', values['chartDomainY'] + values['labelOffsetX']);
      // If 0 is between minY and maxY draw X axis labels at 0
    } else {
      xAxisLeftLabel
        .attr('y', this.scaleY(0) + values['labelOffsetX'])
        .attr('x', this.scaleX(0) + this.scaleX.bandwidth() / 2);
      xAxisRightLabel
        .attr('y', this.scaleY(0) + values['labelOffsetX']);
      // And a nice 0 at the Y axis
      if (values['drawYAxis']) {
        selection.append('text')
          .attr('id', `zeroValue-${this.id}`)
          .attr('x', values['chartDomainX'] - values['labelOffsetY'])
          .attr('y', this.scaleY(0))
          .attr('text-anchor', 'end')
          .attr('dy', '0.35em')
          .attr('fill', values['labelColor'])
          .attr('font-size', values['labelFontSize'])
          .attr('font-family', 'Roboto, sans-serif')
          // .text(values['labelFormatY'] && values['labelFormatY'] !== '' ? numeral(0).format(values['labelFormatY']) : 0)
          .text(this.formatNumberDecimals(0, values['labelDecimalsY'], values['formatLocale']['value'], ));
      }
    }
  }

  public animateNBars(timeline, values, data) {

    for (let idx = 0 ; idx < data.length; idx++) {
       timeline.from(`#chart-bars-${this.id}-${idx}`, 1, {attr: {height: '0'}}, `bar${idx}-=0.5`);
    }
    return timeline;
  }

  public animateNBullets(timeline, values, data, bulletnumber) {
    timeline.fromTo(`#bulletGroep-${this.id}-${bulletnumber}`, 1, { opacity: 0 }, { opacity: 1 , delay: 1}, `bullet${bulletnumber}`);
  }

  public animateColorSpecificBar(timeline, values, barnumber) {

      timeline.to(`#chart-bars-${this.id}-${barnumber}`, 1, {attr: {fill: '#c4542d'}, delay: 1}, `startColor-${barnumber}`);

  }

  // public drawBars(selection, values, data, setNumber?) {
  //   let barHeights = {};
  //   let list = _.map(data, a => a[0]);
  //   let base = null;
  //   let drawBar = null;
  //
  //   if (values['maxY'] < 0) {
  //     base = values['maxY'];
  //   } else if (values['minY'] > 0) {
  //     base = values['minY'];
  //   } else {
  //     base = 0;
  //   }
  //   let h = v => Math.abs(v * values['chartDomainHeight'] / (values['maxY'] - values['minY']));
  //
  //   drawBar = (value, index, setNumber?) => {
  //     let g1 = selection.append('g')
  //       .attr('transform', `translate(0, ${this.scaleY(base)})`);
  //     let g2 = g1.append('g');
  //     if (value >= base) {
  //       g2.attr('transform', 'scale(1, -1)');
  //     }
  //     let id = setNumber === null || setNumber === undefined ? `chart-bars-${this.id}-${index}` : `chart-bars-${this.id}-${setNumber}-${index}`;
  //     barHeights[id] = h(value);
  //     let bar = g2.append('rect')
  //       .attr('id', id)
  //       .classed(`chart-bars-${this.id}`, true)
  //       .attr('x', this.scaleX(index))
  //       .attr('y', 0)
  //       .attr('width', this.scaleX.bandwidth())
  //       .attr('height', h(value))
  //       .attr('fill', values['barColor'])
  //       .attr('data-value', value);
  //     console.log('hallo')
  //     if (values['barStrokeWidth'] > 0) {
  //       bar.attr('stroke', values['barStrokeColor']);
  //       bar.attr('stroke-width', values['barStrokeWidth']);
  //     } else {
  //       bar.attr('stroke', 'none');
  //     }
  //   };
  //
  //
  //   _.map(list, (value, index) => {
  //     drawBar(value, index, setNumber);
  //   });
  //   return barHeights;
  // }

  public animateStatbelLogoAppearAndScaleBarsOneAtATime(timeline) {
    timeline.from(`#statbel-logo-text-group-${this.id}`, 1, { opacity: 0 }, 'startAppearStatbelLogoText');

    timeline.from(`#statbel-logo-bars-ltr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars01');
    timeline.from(`#statbel-logo-bars-lbr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars01');
    timeline.from(`#statbel-logo-bars-rtl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars01');
    timeline.from(`#statbel-logo-bars-rbl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars01');

    timeline.from(`#statbel-logo-bars-ltm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars02');
    timeline.from(`#statbel-logo-bars-lbm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars02');
    timeline.from(`#statbel-logo-bars-rtm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars02');
    timeline.from(`#statbel-logo-bars-rbm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars02');

    timeline.from(`#statbel-logo-bars-ltl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars03');
    timeline.from(`#statbel-logo-bars-lbl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars03');
    timeline.from(`#statbel-logo-bars-rtr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars03');
    timeline.from(`#statbel-logo-bars-rbr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars03');
  }

  public animateStatbelLogoAppearAndScaleBarsAllAtOnce(timeline) {
    timeline.from(`#statbel-logo-text-group-${this.id}`, 1, { opacity: 0 }, 'startAppearStatbelLogoText');

    timeline.from(`#statbel-logo-bars-ltr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-lbr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-rtl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-rbl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars');

    timeline.from(`#statbel-logo-bars-ltm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-lbm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-rtm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-rbm-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars');

    timeline.from(`#statbel-logo-bars-ltl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-lbl-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-rtr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 100%' }, 'startAppearStatbelLogoBars');
    timeline.from(`#statbel-logo-bars-rbr-${this.id}`, 1, { scaleY: 0, transformOrigin: '50% 0%' }, 'startAppearStatbelLogoBars');

    timeline.from(`#twitter-${this.id}`, 1, { opacity: 0 , delay: 2}, 'animateAdres');
    timeline.from(`#website-${this.id}`, 1, { opacity: 0 , delay: 2}, 'animateAdres');
  }
}



// WEBPACK FOOTER //
// ./src/app/animations/demo-statbel-triptych-bar/demo-statbel-triptych-bar.component.ts